import { SubmitNewQuote } from "@/components/SubmitNewQuote";
import {
  consumePendingDealSubmittedPayload,
  pushCustomerPortalAnalyticsEvent,
} from "@/utils";
import { useEffect, useRef } from "react";

export function EmailThankYouPage() {
  const hasTrackedPageOpenRef = useRef(false);

  useEffect(() => {
    if (hasTrackedPageOpenRef.current) {
      return;
    }

    const payload = consumePendingDealSubmittedPayload();
    if (payload) {
      pushCustomerPortalAnalyticsEvent({ payload });
    }
    hasTrackedPageOpenRef.current = true;
  }, []);

  return (
    <div className="max-w-[1500px] mx-auto h-full min-h-screen flex px-4 xl:px-16 py-[10dvh] flex-col items-center">
      <div className="flex flex-col justify-center gap-[10dvh]">
        <div className="w-full h-full flex flex-col gap-16 xl:flex-row xl:justify-between items-center">
          <div className="flex flex-col gap-12 w-full xl:w-[50%]">
            <div className="relative h-16 w-16 rounded-full flex justify-center items-center">
              <div className="bg-[#17D384] h-full w-full animate-pulse-scale rounded-full absolute inset-0" />
              <img
                src="/checkout-success/success-check.svg"
                className={`bg-[#17D384] h-full w-full p-4 rounded-full absolute inset-0 z-10`}
                alt="Success icon"
              />
            </div>
            <h2 className="text-6xl font-semibold">Email Sent Successfully!</h2>
            <p>
              Thank you for requesting your quote details! We've sent the
              information to your email address. Please check your inbox (and
              spam folder if necessary).
            </p>
            <p>
              If you have any questions or need further assistance, please
              contact
            </p>
            <a
              href="mailto:noa@themilesmarket.com"
              className="bg-[#ECFAFF] w-fit px-6 py-2 rounded-lg flex gap-2 hover:underline"
            >
              <img src="/checkout-success/send.svg" alt="send icon" />{" "}
              noa@themilesmarket.com
            </a>
          </div>
          <img
            src="/checkout-success/banner.svg"
            className="h-full max-h-[85dvh]"
            alt="Thank you banner illustration"
          />
        </div>

        <SubmitNewQuote />
      </div>
    </div>
  );
}
